export const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error('Geolocation not supported'));
    }

    const options = {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 0
    };
    navigator.geolocation.getCurrentPosition(
      // Success callback
      (position) => {
        const latLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        resolve(latLng);
      },
      // Error callback
      (error) => {
        reject(new Error(handleGeoloactionError(error)));
      },
      // Pass in the options
      options
    );
  });
};

export const startWatchLocation = (successCallback, errorCallback) => {
  if (!navigator.geolocation) {
    return errorCallback(new Error('Geolocation not supported'));
  }
  const options = {
    enableHighAccuracy: true,
    timeout: Infinity,
    maximumAge: 0
  };
  const watchId = navigator.geolocation.watchPosition(
    // Success callback
    (position) => {
      const latLng = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      successCallback(latLng, watchId);
    },
    // Error callback
    (error) => {
      errorCallback(new Error(handleGeoloactionError(error, watchId)));
    },
    // Pass in the options
    options
  );
  return watchId;
};

export const stopWatchLocation = (watchId) => {
  return navigator.geolocation.clearWatch(watchId);
};

const handleGeoloactionError = function (error, watchId) {
  switch (error.code) {
    case error.PERMISSION_DENIED: {
      error.msg = 'User denied the request for Geolocation.';
      error.watchId = watchId;
      break;
    }
    case error.POSITION_UNAVAILABLE: {
      error.msg = 'Location information is unavailable.';
      error.watchId = watchId;
      break;
    }
    case error.TIMEOUT: {
      error.msg = 'The request to get user location timed out.';
      error.watchId = watchId;
      break;
    }
    case error.UNKNOWN_ERROR: {
      error.msg = 'The request to get user location timed out.';
      error.watchId = watchId;
      break;
    }
    default: {
      break;
    }
  }
  return error;
};
